import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ErroGraphicResultsApi } from 'src/service/apis-cockpit';


@Component({
    selector: 'cp-widget',
    templateUrl: './cp-widget.component.html',
    styleUrls: ['./cp-widget.component.css'],
    standalone: false
})
export class CpWidgetComponent implements OnChanges {

  @Input() errorList: ErroGraphicResultsApi[];
  @Input() idGraphic: number;
  @Input() isHideLoading: boolean;

  isInfo: boolean;
  graphicOpacity = 1;
  tooltipMessage = "";

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.errorList) {
      this.restore();
      this.load();
    }
  }

  private restore() {
    this.graphicOpacity = 1;
    this.isInfo = false;
  }

  async load() {
    if (typeof (this.errorList) != 'undefined' && this.errorList.length > 0) {
      let opacity = 1;
      let message = "";
      const lidGraphic = this.idGraphic;
      this.errorList.forEach(function (value) {
        if (typeof (value.message) !== 'undefined' && value.message?.length > 0 &&
          (lidGraphic <= 0 || value.idGraphic == lidGraphic)) {
          opacity = 0.1;
          message = value.message;
        }
      });

      this.graphicOpacity = opacity;
      this.tooltipMessage = message;

      if (this.tooltipMessage?.length > 0)
        this.isInfo = true;
      else
        this.isInfo = false;
    }
  }
}
